<template>
  <v-card id="tocwdgt" 
    flat width="100%" color="lsidebg"
    :max-width="$vuetify.breakpoint.mdAndUp?'300':'false'"
    class="mb-2 mr-sm-3 mr-md-0 pb-3 d-print-none stick"
  > 
    <v-card-title class="pt-2 pb-0 pl-3">
    <h5 class="wdgt-title">{{$t('database.wdg_contents')}}</h5>
    </v-card-title>

    <v-navigation-drawer permanent color="transparent" >
        <v-list dense flat class="pt-1">
        <v-list-item
        class="pagetoc ml-4 py-0 px-2 darkgrey--text"
        v-for="(item, i) in this.toc"
        :key="i"
        @click="$vuetify.goTo('#'+ item.id, {'offset':6})"
        >
        <!--:href="'#'+ item.id"-->
        {{item.title}}
        </v-list-item>
    </v-list>
    </v-navigation-drawer>
  </v-card>
</template>


<script>
  export default {
    name:'hklii-tocwidget',
    props: {           
      toc: {type: Array, required: true}
    }
  }
</script>


<style scoped>
  .pagetoc {
    font-size: 9.5pt !important;
    border-left: 2px solid var(--v-link-lighten4);
  }

  .pagetoc:hover {
    font-size: 9.5pt !important;
    border-left: 2px solid var(--v-link-base);
  }

  .pagetoc li.router-link-active {
    border-left-color: currentColor;
  }
</style>